import { Container, Grid } from "@material-ui/core"
import HomePage from "../Home"
import CbCategoria from "./cbCategoria"
import CbPaquete from "./cbPaquetes"
import TGrupo from "./TGrupo"
const CambiosGrupales = () => {
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={6}>
                        <CbCategoria />
                    </Grid>
                    <Grid item xs={6}>
                        <CbPaquete />
                    </Grid>
                    <Grid item xs={12}>
                        <TGrupo />
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default CambiosGrupales